import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Crop } from 'src/app/models/crop';
import { ApiService } from 'src/app/services/api.service';
import { CustomMessageService } from 'src/app/services/custom.message.service';
import { StaticFields } from 'src/app/shared/staticFields';
import { ColDef, GridOptions, GridReadyEvent, IMultiFilterParams, StatusPanelDef } from 'ag-grid-community';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-metrics',
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.scss']
})
export class MetricsComponent implements OnInit {
gridApi: any;
  rowData: any[] = [];
  showSearch: boolean = true;
  searchHeight: number;
  sideBarHeight: string;
  selectedCrop: Crop;
  levels: any[] = [{name: 'Program(s)'},{name: 'Region(s)'},{name: 'EZ(s)'}];
  selectedLevel: any;
  inclusions: any[];
  selectedInclusions: any;
  appUsers: any[] = [];
  selectedUser: any;
  beginDate: Date;
  endDate: Date;
  maxDate: Date = new Date();
  regions: any[] = [];
  ezs: any = [];
  programs: any = [];
  metricType: string;
  public columnDefs: ColDef[] = [];
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    filterParams: {
        filters: [
          {
            filter: "agSetColumnFilter",
            filterParams: { buttons: ["clear"] }
          },
        ]
      } as IMultiFilterParams,
    minWidth : 50, 
    resizable: true,
  };
  public statusBar: {
    statusPanels: StatusPanelDef[];
  } = {
    statusPanels: [
      { statusPanel: 'agTotalRowCountComponent', align: 'left' },
      { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left',  },
      { statusPanel: 'agFilteredRowCountComponent', align : 'left' },
      { statusPanel: 'agSelectedRowCountComponent', align : 'left' },
    ],
  };
  gridOptions : GridOptions = {
    context: {
      componentParent: this,
    },
    autoSizeStrategy: {
      type: 'fitCellContents'
    },
    singleClickEdit: true,
    tooltipShowDelay: 100,
    sideBar: { toolPanels: [{
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivotMode: true,
      },
    },
    'filters'] }
  }

  get crops(): Crop [] {
    return StaticFields.crops?.filter(ele => ele.isActive);
  }

  get disableSearch(): boolean {
    if (this.metricType === 'allUsers' && !this.beginDate)
      return true;
    else if (this.metricType === 'cropCnt' && !this.selectedCrop)
      return true;
    else if (this.metricType === 'activityCnt' && !(this.selectedInclusions && this.selectedInclusions.length > 0))
      return true;
    else if (this.metricType)
      return false;
    return true;
  }

  get disableReset(): boolean {
    return this.beginDate || this.endDate || this.metricType || this.selectedCrop || this.selectedInclusions || 
    this.selectedLevel || this.selectedUser || this.rowData.length > 0 ? false : true;
  }

  get SearchHoverText(): string {
    if (this.metricType === 'allUsers' && !this.beginDate)
      return 'Date Range required';
    else if (this.metricType === 'cropCnt' && !this.selectedCrop)
      return 'Crop required';
    else if (this.metricType === 'activityCnt' && !(this.selectedInclusions && this.selectedInclusions.length > 0))
      return 'Program, EZ or Region required';
    else if (this.metricType)
      return 'Search Data';
    return 'Select a Metric Type';
  }

  constructor(public customMessageService: CustomMessageService, private apiService : ApiService, public commonService : CommonService) { 
  }

  ngOnInit(): void {
    this.apiService.getData('GetAllUsers', null, false).subscribe((result : any) => {
      this.appUsers = result;
    });
    if (StaticFields.appUserId && StaticFields.crops && StaticFields.crops.length > 0)
      this.initialCalls();
    else {
      const interval = setInterval(() => {
        if (StaticFields.appUserId && StaticFields.crops && StaticFields.crops.length > 0) {
          this.initialCalls();
          clearInterval(interval);
        }
      }, 800);
    }
    
    window.addEventListener("resize", () => this.setHeight());
    const elements = document.getElementsByClassName("footer-container");
    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).style.display = 'none';
    }
  }

  initialCalls() {
    this.rowData.splice(0);
    this.setHeight();
    // if (StaticFields.precodePreference && StaticFields.precodePreference.appUserId) {
    //   this.selectedCrop = this.crops.find(ele => ele.Name == StaticFields.precodePreference.crop);
    //   this.selectedLevel = this.levels.find(ele => ele.name == StaticFields.precodePreference.level);
    //   this.getRegionsPrograms();
    // }
  }

  setHeight() {
    this.searchHeight = window.innerHeight - 195;
    this.sideBarHeight = `${this.searchHeight + 50}px`;
    // let gridHgt = StaticFields.precodeScreenData?.filters && Object.keys(StaticFields.precodeScreenData.filters).length > 0 ? 92 : 100;
    // if (window.innerWidth > 1500 && window.innerWidth < 1770 && gridHgt === 92)
    //   gridHgt = 94;
    // if (window.innerWidth > 1770)
    //   gridHgt = gridHgt === 100 ? gridHgt + 4 : gridHgt + 8;
    //this.gridHeight = `${gridHgt}%`;
  }
  changeCrop() {
    this.getRegionsPrograms();
  }

  reset() {
    this.beginDate = this.endDate = this.metricType = this.selectedCrop = this.selectedInclusions = this.selectedLevel = this.selectedUser = null;
    this.rowData.splice(0);
    this.showSearch = true;
  }

  getRegionsPrograms() {
    let params = new HttpParams();
    params = params.append('cropId', this.selectedCrop.Id);
    this.apiService.getRADData(`Regions?$filter=CropId eq ${this.selectedCrop.Id} and Status/Name eq 'Active'&$select=Id,Code,Description`, false).subscribe((result : any) => {
      if (result.value.findIndex((v: any) => v.Code.toUpperCase() === 'WW') === -1)
        result.value.push({Code: 'WW', Description: 'Worldwide'});
      result.value = result.value.sort((a: any , b: any) => a.Code.localeCompare(b.Code));  
      this.regions = result.value;
      if (this.selectedLevel && this.selectedLevel.name === "Region(s)")
        this.changeLevel();
    });
    this.getEvaluationZonePreference();    
    this.getProgramPreference();
  }

  getEvaluationZonePreference() {   
    this.apiService.getOData(`EvaluationZonePreferences?$filter=CropName eq '${this.selectedCrop.Name}' and IsActive&$select=Id,Code,Description`).subscribe((result : any) => {  
      result.value = result.value.sort((a: any , b: any) => a.code.localeCompare(b.code)); 
      this.ezs = result.value;
      if (this.selectedLevel && this.selectedLevel.name === "EZ(s)")
        this.changeLevel();
    });
  }

  getProgramPreference() {
    let selectCountry = '';
    if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
      selectCountry = ',CountryName';
    this.apiService.getOData(`ProgramPreferences?$filter=CropName eq '${this.selectedCrop.Name}'and IsActive&$select=Id,Code,Description${selectCountry}`).subscribe((result : any) => {
      if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
        result.value = result.value.filter((r: any) => StaticFields.countriesToShow.includes(r.countryName.toUpperCase()));
      result.value = result.value.sort((a: any , b: any) => a.code.localeCompare(b.code)); 
      this.programs = result.value;
      if (this.selectedLevel && this.selectedLevel.name === "Program(s)")
        this.changeLevel();   
    });
  }
  
  changeLevel() {
    this.selectedInclusions = null;
    if (this.selectedLevel.name === "Program(s)") {
      this.inclusions = this.programs.map((d: any) => { return {id: d.id, code: d.code, desc: d.description};});
    } else if (this.selectedLevel.name === "Region(s)") {
      this.inclusions = this.regions.map((d: any) => { return {code: d.Code, desc: d.Description};});
    } else if (this.selectedLevel.name === "EZ(s)") {
      this.inclusions = this.ezs.map((d: any) => { return {code: d.code, desc: d.description};});
    } else if (this.inclusions)
      this.inclusions.splice(0);
    if (StaticFields.precodePreference && StaticFields.precodePreference.appUserId && this.inclusions.length > 0) {
      if (this.selectedCrop.Name === StaticFields.precodePreference.crop) {
        const inclPredicate = StaticFields.precodePreference.include.split(",").some(ele => this.inclusions.findIndex((i: any) => i.code === ele) > -1);
        const selInclusions = inclPredicate && StaticFields.precodePreference.include!= "" && StaticFields.precodePreference.include.split(",").length > 0 ? StaticFields.precodePreference.include.split(",") : [];
        this.selectedInclusions = this.inclusions.filter(i => selInclusions.includes(i.code));
      }
    }
  }

  onLevelSearch(word: string, item: { code: string, desc: string }): boolean {
    return item.code.toLocaleLowerCase().startsWith(word.toLocaleLowerCase());
  }

  onGridReady($event: GridReadyEvent<any>) {
    this.gridApi = $event.api;
  }

  SearchData() {
    this.columnDefs.splice(0);
    this.rowData.splice(0);
    let postData : any = {};
    postData['crop'] = this.selectedCrop?.Name;
    postData['level'] = this.selectedLevel?.name;
    postData['include'] = this.selectedInclusions?.map((i: any) => i.code).join();
    postData['userId'] = this.selectedUser?.id;
    postData['beginDate'] = this.beginDate?.toISOString();
    postData['endDate'] = this.endDate?.toISOString();
    postData['type'] = this.metricType;
    this.apiService.postData('SearchMetrics', postData, false).subscribe((res: any) => {
      if (res && res.length > 0) {
        Object.keys(res[0]).forEach(k => {
          if (k === 'timetaken')
            this.columnDefs.push({ field: k, headerName : 'TimeTaken (sec)' });
          else if (k === 'dateCoded' || k === 'lastLogin' || k === 'searchedOn')
            this.columnDefs.push({ field: k, headerName : this.capitalizeHeader(k), cellRenderer: (params: any) => { 
              return new Date ((new Date(params.data[k])) + " UTC").toLocaleString();
            }})
          else
            this.columnDefs.push({ field: k, headerName : this.capitalizeHeader(k) });
        });
        this.rowData = res;
      } else 
        this.customMessageService.showMessage({'severity': 'warn', summary: 'Not Found', detail: "No records found for your search."}); 
    });
  }

  capitalizeHeader(header: string) {
    return header.charAt(0).toUpperCase() + header.slice(1);
  }

  export() {
    this.commonService.downloadExcelFile(this.gridApi);
  }

}
